import IndividualBankDetails from './IndividualBankDetails';

function BankDetails() {
  return <IndividualBankDetails />;
}

export default BankDetails;
